
import React, { useEffect, useState } from 'react';
import { errorIcon } from '../../../Helper/svgs';
import './Textfield.css';

const Textfield = (props) => {
    const [value, setValue] = useState(props.value);
    const [error, setError] = useState(false);

    const handleChange = (newValue) => {
        if (newValue < props.min) {
            setError(true);
            setValue(newValue);
            props.onChange(props.min);
        } else if (newValue > props.max) {
            setError(false);
            setValue(props.max);
            props.onChange(props.max);
        } else {
            setError(false);
            setValue(newValue);
            props.onChange(newValue);
        }
    };
    useEffect(() =>
        handleChange(props.tfValue)
        ,
        [props.tfValue])
    return (
        <div className={`${props.className} container-horizontal res-gap-8 align-right`}>
            {error && (
                <div className='error-icon'>
                    {errorIcon()}
                </div>
            )}
            <div className={`textfield ${error ? 'error' : ''}`}>
                {props.leading != null && (
                    <span className="symbol">
                        {props.leading}
                    </span>
                )}
                <input
                    type="number"
                    className="text-input"
                    value={value}
                    placeholder='0'
                    onChange={(event) => handleChange(event.target.value)}
                />
                {props.trailing != null && (
                    <span className="symbol">
                        {props.trailing}
                    </span>
                )}
            </div>
        </div>
    );
};

export default Textfield;

// import React, { useState, useEffect } from 'react'
// import { errorIcon } from '../../../assets/svgs/svgs';
// import './Textfield.css'
// export default function Textfield(props) {
//     const [value, setValue] = useState(props.min);
//     const [error, setError] = useState(false);

//     useEffect(() => {

//         // Update internal value when external value changes
//         setValue(props.tfValue);

//         if (props.min > parseInt(value) || parseInt(value) > props.max || value.length === 0) {
//             if (parseInt(value) > props.max) {
//                 setValue(props.max)
//             }
//             else
//                 setError(true);
//         }
//         else {
//             setError(false);
//         }



//     }, [props.tfValue]);


//     return (
//         <div className={`${props.className} container-horizontal res-gap-8 align-right`}>
//             {error ?
//                 <div className='error-icon'>
//                     {errorIcon()}
//                 </div>
//                 : ''
//             }
//             <div className={`textfield ${error ? 'error' : ''}`}>

//                 {
//                     props.leading != null ?
//                         <span className="symbol">
//                             {props.leading}
//                         </span>
//                         : ''
//                 }
//                 <input
//                     type="number"
//                     className="text-input"
//                     value={value}
//                     placeholder='0'

//                     onChange={(x) => {
//                         setValue(x.target.value);

//                         props.onChange(x.target.value);
//                     }}
//                 />

//                 {
//                     props.trailing != null ?
//                         <span className="symbol">
//                             {props.trailing}
//                         </span>
//                         : ''
//                 }
//             </div>
//         </div>

//     )
// }
